export default __webpack_public_path__ + "static/media/LaptopMan.d1d59659.svg";